<script>
import { Input } from 'element-ui'

function numberJoin(val) {
  const idList = val.match(/\d+/g) || []

  return idList.map(id => Number(id))
}
function stringJoin(val) {
  const commaValue = val.trim().replace(/[\s|，]/g, ',')

  return commaValue.split(',').filter(item => item)
}

const formatterStub = {
  number: numberJoin,
  string: stringJoin
}

export default {
  name: 'MultipleInput',
  extends: Input,
  props: {
    value: [String, Number, Array],
    // 直接传 formatter 函数或者使用标准的格式化函数
    formatter: [Function, String],
  },
  // dom挂载后添加回车事件
  mounted() {
    this.$el.addEventListener('keyup', event => {
      this.$emit('keyup', event)
      if (event.key === 'Enter' || event.keyCode === 13) {
        this.handleChange(event)
        this.$emit('submit', event)
      }
    })
  },
  methods: {
    handleChange(event) {
      const formatter = this.formatter
      let resolvedValue = event.target.value

      if (formatter) {
        if (typeof formatter === 'function') {
          resolvedValue = this.formatter(resolvedValue)
        } else if (typeof formatter === 'string') {
          if (formatterStub[formatter]) {
            resolvedValue = formatterStub[formatter](resolvedValue)
          }
        }
      }

      this.$emit('change', resolvedValue)

      /* copy 原生 el-input 的 input 事件的通知 */
      this.$emit('input', resolvedValue)

      // ensure native input value is controlled
      // see: https://github.com/ElemeFE/element/issues/12850
      this.$nextTick(this.setNativeInputValue)
      /* 模拟原生 el-input 的 input 事件的通知end */
    },
    // handleInput(event) {
    //   console.log(event.target.value)
    //   // should not emit input during composition
    //   // see: https://github.com/ElemeFE/element/issues/10516
    //   if (this.isComposing) return

    //   // hack for https://github.com/ElemeFE/element/issues/8548
    //   // should remove the following line when we don't support IE
    //   if (event.target.value === this.nativeInputValue) return

    //   this.$emit('input', event.target.value)

    //   // ensure native input value is controlled
    //   // see: https://github.com/ElemeFE/element/issues/12850
    //   this.$nextTick(this.setNativeInputValue)
    // },
  }
}
</script>
